import { RoleName } from '../../models';
import { FetchContext, responseErrorHandler } from '..';

export const getUserImpersonation: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<RoleName | undefined> = async (fetchContext, accessToken) => {
  const response = await fetch(`${fetchContext.baseUrl}/api/admin/user-impersonations/me`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });

  if (response.status === 404) {
    return undefined;
  }

  return responseErrorHandler<RoleName>(fetchContext.errorStore, response, 'get user impersonation', false);
};
